import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material';
import { clampIsoDateToToday, getTodayIsoDate } from "../../../utils/reportDateLimits";
import Backdrop from "@mui/material/Backdrop";
import AppLoader from '../../../components/AppLoader/AppLoader';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import XLSX, { boldRows } from "utils/xlsxStyled";
import eOpsLogo from '../../../images/eops.png';
import ReportExportButtons from "../../Report/components/ReportExportButtons";
import "../../Report/reportPageLayout.scss";
import "../../Report/ChangeOfAttributesStatusReport.scss";
import "./ComplaintsSummary.scss";
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.jpg";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import { cfpBaseUrl } from '../../../network/urls';
import { convertDate, convertDatewithTime, getName, subdivisionName } from '../../../services/Functions';
import '../../../style/common.scss';
import { resolveOfficeCodeForAdmin, resolveReportGoOfficeCode } from "../../../utils/adminCompany";
const ComplaintsSummary = () => {

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Adding 1 because months are 0-indexed
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId, divisionCode, hierarchy: userHierarchy, selectedAdminCompanyCode } = useSelector(state => state.auth)
  const tableRef = useRef(null);
  const [assmntBatchWise, setAssmntBatchWise] = useState([]);
  // const { officeCode: offCode } = useSelector(state => state.officeCode)
  const offCode = userHierarchy == 1
    ? code
    : userHierarchy == 2
      ? code.slice(0, 2)
      : userHierarchy == 3
        ? code.slice(0, 3)
        : userHierarchy == 4
          ? code.slice(0, 4)
          : userHierarchy == 5
            ? code.slice(0, 5)
            : code;
  const [tableData, setTableData] = useState([]);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [circleCode, setCircleCode] = useState('');
  const [circleName, setCircleName] = useState('');
  const [officeCode, setOfficeCode] = useState();
  const [officeName, setOfficeName] = useState('');
  const [selectedDivision, setSelectedDivision] = useState('');
  const [selectedSubDivision, setSelectedSubDivision] = useState('');
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [hierarchy, setHierarchy] = useState('');
  const [filteredCircles, setFilteredCircles] = useState([]);
const [isGoDisabled, setIsGoDisabled] = useState(true); 
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const [dateFrom, setDateFrom] = useState(getCurrentDate())
  const [dateTo, setDateTo] = useState(getCurrentDate())
  const [totals, setTotals] = useState({});
  const [complaints, setComplaints] = useState([])

  const [subDivisions, setSubDivisions] = useState(JSON.parse(window.localStorage.getItem('subDivisions')) || []);
  const [selectedCompanyCode, setSelectedCompanyCode] = useState('');

  useEffect(() => {
    if (String(code) === "10" && selectedAdminCompanyCode) {
      const company = String(selectedAdminCompanyCode);
      setSelectedCompanyCode(company);
      setOfficeCode(company);
    }
  }, [code, selectedAdminCompanyCode]);

  const [currentBillingStats, setCurrentBillingStats] = useState({
    batches: [],
    amountsBatchWise: [],
    unitsBatchWise: [],
    categories: ['Total', 'Dom.', 'Com.', 'Ind.', 'Arg.', 'Oth.'],
    amountsCategoryWise: [],
  })
  const OffLevel = String(officeCode).length;
  const [billingReportPopup, setBillingReportPopup] = useState(false);

  const companyCode = code.slice(0, 2)

  const getLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOLOGO
      case '12':
        return GEPCOLOGO
      case '13':
        return FESCOLOGO
      case '14':
        return IESCOLOGO
      case '15':
        return MEPCOLOGO
      case '16':
        return PESCOLOGO
      case '27':
        return SEPCOLOGO
      case '37':
        return HESCOLOGO
      case '48':
        return QESCOLOGO
      case '59':
        return TESCOLOGO
      default:
        return MEPCOLOGO
    }
  }

  const getCompanies = (code) => {
    switch (code) {
      case '11':
        return "Lahore Electric Supply Company"
      case '12':
        return "Gujranwala Electric Power Company"
      case '13':
        return "Faisalabad Electric Supply Company"
      case '14':
        return "Islamabad Electric Supply Company"
      case '15':
        return "Multan Electric Power Company"
      case '16':
        return "Peshawar Electric Supply Company"
      case '27':
        return "Sukkur Electric Power Company"
      case '37':
        return "Hyderabad Electric Supply Company"
      case '48':
        return "Quetta Electric Supply Company"
      case '59':
        return "Tribal Electric Supply Company"
      default:
        return "Multan Electric Power Company"
    }
  }

  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = officeName || "MEPCO Region";
      let dateToPrint = getCurrentDateFormatted(new Date());
      const title = dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
        ? `Complaints Summary Report of ${dateFrom}`
        : `Complaints Summary Report from ${dateFrom ? convertDate(dateFrom) : '-'} to ${dateTo ? convertDate(dateTo) : '-'}`;
      const headers = [
        [
          OffLevel == 2
            ? "Circle"
            : OffLevel == 3
              ? "Division"
              : OffLevel == 4
                ? "Sub-Division"
                : OffLevel == 5
                  ? "Sub-Division"
                  : "",
          'Pending',
          'Allocated',
          'On-Hold',
          'Resolved',
          'Closed',
          'Total'
        ].map((header) => ({
          content: header,
          styles: { halign: "center", fontStyle: "bold" },
        })),
      ];

      const body = [];

      if (tableData && tableData.length > 0) {
        tableData.forEach((item) => {
          body.push([
            { content: item.OfficeName || "-", styles: { halign: "left" } },
            { content: formatWithCommas(item.PendingTotalCount || 0), styles: { halign: "center" } },
            { content: formatWithCommas(item.AllocatedTotalCount || 0), styles: { halign: "center" } },
            { content: formatWithCommas(item.OnholdTotalCount || 0), styles: { halign: "center" } },
            { content: formatWithCommas(item.ResolvedTotalCount || 0), styles: { halign: "center" } },
            { content: formatWithCommas(item.ClosedTotalCount || 0), styles: { halign: "center" } },
            { content: formatWithCommas(item.TotalCount || 0), styles: { halign: "center" } },
          ]);
        });

        const totalPending = tableData.reduce((sum, item) => sum + (item.PendingTotalCount || 0), 0);
        const totalAllocated = tableData.reduce((sum, item) => sum + (item.AllocatedTotalCount || 0), 0);
        const totalOnHold = tableData.reduce((sum, item) => sum + (item.OnholdTotalCount || 0), 0);
        const totalResolved = tableData.reduce((sum, item) => sum + (item.ResolvedTotalCount || 0), 0);
        const totalClosed = tableData.reduce((sum, item) => sum + (item.ClosedTotalCount || 0), 0);
        const grandTotal = tableData.reduce((sum, item) => sum + (item.TotalCount || 0), 0);

        body.push([
          { content: "Total", styles: { halign: "left", fontStyle: "bold", fillColor: "#f8f9fa" } },
          { content: formatWithCommas(totalPending), styles: { halign: "center", fontStyle: "bold", fillColor: "#f8f9fa" } },
          { content: formatWithCommas(totalAllocated), styles: { halign: "center", fontStyle: "bold", fillColor: "#f8f9fa" } },
          { content: formatWithCommas(totalOnHold), styles: { halign: "center", fontStyle: "bold", fillColor: "#f8f9fa" } },
          { content: formatWithCommas(totalResolved), styles: { halign: "center", fontStyle: "bold", fillColor: "#f8f9fa" } },
          { content: formatWithCommas(totalClosed), styles: { halign: "center", fontStyle: "bold", fillColor: "#f8f9fa" } },
          { content: formatWithCommas(grandTotal), styles: { halign: "center", fontStyle: "bold", fillColor: "#f8f9fa" } },
        ]);
      } else {
        body.push([
          { content: "No Data Found", colSpan: 7, styles: { halign: "center", textColor: [255, 0, 0], fontStyle: "bold" } },
        ]);
      }


      const pdf = new jsPDF('landscape', 'mm', 'a4', { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 25 : 30;
      const logoHeight = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 20 : 10;
      pdf.addImage(getLogo(companyCode), 'PNG', 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition = companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 43 : 17;
      pdf.addImage(eOpsLogo, 'PNG', eOpsLogoXPosition, companyCode === '12' || companyCode === '13' || companyCode === '11' || companyCode === '16' || companyCode === '27' || companyCode === '48' || companyCode === '59' ? 12 : 17, eOpsLogoWidth, eOpsLogoHeight);

      pdf.setFontSize(10);
      // pdf.text(convertDatewithTime(new Date()), pageWidth - 50, 12);
      // pdf.text("Name: " + name, pageWidth - 50, 17);
      // pdf.text("Designation: " + roleName, pageWidth - 50, 22);

      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, { align: 'center' });
      pdf.text(`Complaints Summary for ${offName}`, pageWidth / 2, 18, { align: 'center' });
      pdf.setFontSize(10);
      pdf.text(title, pageWidth / 2, 25, { align: 'center' });

      pdf.autoTable({
        startY: 28,
        head: headers,
        body: body,
        styles: { cellPadding: 1, fontSize: 8, halign: "center", lineWidth: 0.25, lineColor: "white" },
        margin: { top: 2 },
        theme: "striped",
        headStyles: { valign: "middle", fillColor: "#2980ba" },
        columnStyles: { 0: { halign: "left" } },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.text(`Page ${i} of ${totalPages}`, pageWidth - 45, pageHeight - 10);
      }

      if (print) {
        pdf.save(`${title}.pdf`);
      } else {
        resolve(pdf);
      }
    });
  };

  const exportToExcel = () => {
    let offName = officeName ? officeName : 'MEPCO Region';
    let dateToPrint = convertDate(new Date());
    const title = dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
      ? `Complaints Summary Report of ${offName} for ${dateFrom}`
      : `Complaints Summary Report of ${offName} from ${dateFrom ? convertDate(dateFrom) : '-'} to ${dateTo ? convertDate(dateTo) : '-'}`;
    const table = tableRef.current;
    const wb = XLSX.utils.table_to_book(table, { sheet: 'Sheet1' });
    const ws = wb.Sheets['Sheet1'];

    const headers = [
      [
        OffLevel == 2 ? "Circle"
          : OffLevel == 3 ? "Division"
            : OffLevel == 4 ? "Sub-Division"
              : OffLevel == 5 ? "Sub-Division"
                : "",
        'Pending',
        'Allocated',
        'On-Hold',
        'Resolved',
        'Closed',
        'Total'
      ]
    ];

    const headingText = title;
    XLSX.utils.sheet_add_aoa(ws, [[headingText]], { origin: "A1" });

    const range = XLSX.utils.decode_range(ws["!ref"]);
    const columnCount = range.e.c - range.s.c + 1;

    ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: columnCount - 1 } }];

    if (!ws["A1"]) ws["A1"] = {};
    ws["A1"].s = { alignment: { horizontal: "center", vertical: "center" }, font: { bold: true } };

    XLSX.utils.sheet_add_aoa(ws, headers, { origin: "A2" });

    boldRows(ws, 1, 1);

    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout]), `${title}.xlsx`);
  };

  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output('bloburl');

    // Create an iframe
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.top = '0';
    iframe.style.left = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Create a cancel button
    const cancelButton = document.createElement('button');
    cancelButton.textContent = 'Cancel';
    cancelButton.style.position = 'fixed';
    cancelButton.style.top = '20px';
    cancelButton.style.right = '20px';
    cancelButton.style.padding = '10px 20px';
    cancelButton.style.backgroundColor = '#ff4d4d';
    cancelButton.style.color = 'white';
    cancelButton.style.border = 'none';
    cancelButton.style.borderRadius = '5px';
    cancelButton.style.cursor = 'pointer';
    document.body.appendChild(cancelButton);

    // Print the PDF when the iframe loads
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    // Remove iframe and cancel button when cancel button is clicked
    cancelButton.addEventListener('click', () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  function getCurrentDateFormatted(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const options = { month: 'short' };
    const month = date.toLocaleString('en-US', options);
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  }

  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append('Authorization', token);
        const formdata = new FormData();
        formdata.append('companyCode', selectedCompanyCode);
        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow',
        };
        try {
          const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
          if (response.ok) {
            const result = await response.json();
            if (result.status === '200') {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some(item => item.circleCode === curr.circleCode)) {
                  acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some(item => item.circleCode === curr.circleCode)) {
          acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || '');

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompany);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode('');
            setSelectedDivision('');
            setSelectedSubDivision('');
            setCircleName('');
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some(item => item.circleCode === curr.circleCode)) {
                acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName('PITC');
      setCircleCode('');
      setSelectedDivision('');
      setSelectedSubDivision('');
      setCircleName('');
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value ? parseInt(event.target.value) : '';
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompanyCode);
      formdata.append('circleCode', selectedCircleCode);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(circle => circle.circleCode === selectedCircleCode);
            const circleName = circle?.circleName || '';
            setOfficeName(circleName.concat(' Circle'));
            setCircleName(circleName);
            setSelectedDivision('');
            setSelectedSubDivision('');
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter(item => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                  acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompanyCode);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode('');
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName('');
            setSelectedDivision('');
            setSelectedSubDivision('');
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(circle => circle.circleCode === selectedCircleCode);
      const circleName = circle?.circleName || '';
      setOfficeName(circleName.concat(' Circle'));
      setCircleName(circleName);
      setSelectedDivision('');
      setSelectedSubDivision('');
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(item => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (!acc.some(division => division.divisionCode === item.divisionCode)) {
            acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode('');
      setSelectedDivision('');
      setSelectedSubDivision('');
      setFilteredSubDivisions([]);
      if (roleTypeName == 'Technical') {
        if (offCode) {
          setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
          let officeName = getName(String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)), subDivisions);
          setOfficeName(officeName.concat(' Region'));
          setCircleName('');
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some(item => item.circleCode === curr.circleCode)) {
              acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (!acc.some(division => division.divisionCode === item.divisionCode)) {
              acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == 'Commercial') {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (!acc.some(division => division.divisionCode === item.divisionCode)) {
                acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompanyCode);
      formdata.append('divisionCode', selectedDivisionCode);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode);
            const divisionName = division?.divisionName || '';
            setOfficeName(divisionName.concat(' Division'));
            setSelectedSubDivision('');
            const uniqueSubDivisions = result.message
              .filter(item => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
                  acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName = filteredDivisions.find(division => division.divisionCode === selectedDivisionCode)?.divisionName || '';
      setOfficeName(divisionName.concat(' Division'));
      setSelectedSubDivision('');
      const uniqueSubDivisions = subDivisions
        .filter(item => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
            acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision('');
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(circleCode ? circleCode.toString() : offCode.toString(), subDivisions);
      setOfficeName(officeName.concat(' Circle'));
      setSelectedSubDivision('');
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(item => item.circleCode == (circleCode ? circleCode : offCode))
        .reduce((acc, item) => {
          if (!acc.some(division => division.divisionCode === item.divisionCode)) {
            acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append('Authorization', token);
      const formdata = new FormData();
      formdata.append('companyCode', selectedCompanyCode);
      formdata.append('subDivisionCode', selectedSubDivisionCode);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow',
      };

      try {
        const response = await fetch(cfpBaseUrl + 'customerFaciliationPortal/subDivWithCompDetails', requestOptions);
        if (response.ok) {
          const result = await response.json();
          if (result.status === '200') {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode);
            const subDivisionName = subDivision?.subDivisionName || '';
            setOfficeName(subDivisionName.concat(' Sub Division'));
          } else {
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName = filteredSubDivisions.find(sub => sub.subDivisionCode === selectedSubDivisionCode)?.subDivisionName || '';
      setOfficeName(subDivisionName.concat(' Sub Division'));
    } else {
      setSelectedSubDivision('');
      let officeName = getName(selectedDivision ? selectedDivision.toString() : offCode.toString(), subDivisions);
      setOfficeName(officeName.concat(' Division'));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == 'Technical') {
      if (offCode) {
        setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
        let offName = getName(String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)), subDivisions);
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == 'Commercial') {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            const effectiveCompany =
              selectedCompanyCode || selectedAdminCompanyCode || offCode;
            setOfficeCode(effectiveCompany);
            setOfficeName(getCompanies(String(effectiveCompany)) || "PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID, selectedAdminCompanyCode, selectedCompanyCode]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some(item => item.circleCode === curr.circleCode)) {
            acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some(item => item.circleCode === curr.circleCode)) {
            acc.push({ circleCode: curr.circleCode, circleName: curr.circleName, companyCode: curr.companyCode });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        setCircleCode(offCode.slice(0, 3));
        const uniqueDivisions = subDivisions
          .filter(item => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (!acc.some(division => division.divisionCode === item.divisionCode)) {
              acc.push({ divisionCode: item.divisionCode, divisionName: item.divisionName, companyCode: item.companyCode });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if ((hierarchy == 4 || cfcLevelId == 4) || (hierarchy == 5 || cfcLevelId == 5)) {
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter(item => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (!acc.some(sub => sub.subDivisionCode === item.subDivisionCode)) {
              acc.push({ subDivisionCode: item.subDivisionCode, subDivisionName: item.subDivisionName, companyCode: item.companyCode });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);



  const connectionTypes = [
    OffLevel == 2
      ? "Circle"
      : OffLevel == 3
        ? "Division"
        : OffLevel == 4
          ? "Sub-Division"
          : OffLevel == 5
            ? "Sub-Division"
            : "",
    'Pending',
    'Allocated',
    'On-Hold',
    'Resolved',
    'Closed',
    'Total'
  ];


  const fetchData = async (officeCode, dateFrom, dateTo) => {
    setViewBackdrop(true); // Start loader

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "officeCode": officeCode,
      "dateFrom": dateFrom,
      "dateTo": dateTo
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    await fetch(cfpBaseUrl + "lineComplaints/GetComplaintCountStatusWiseHierarchical", requestOptions)
      .then((response) => response.json())
      .then(async (result) => {
        if (result.status === "200") {
          const Data = result.data;

          const mergedData = Object.values(
            Data.reduce((acc, { OfficeCode, OfficeName, Status, TotalCount }) => {
              if (!acc[OfficeCode]) {
                acc[OfficeCode] = {
                  OfficeCode,
                  OfficeName,
                  PendingTotalCount: 0,
                  ClosedTotalCount: 0,
                  AllocatedTotalCount: 0,
                  ResolvedTotalCount: 0,
                  OnholdTotalCount: 0,
                  TotalCount: 0
                };
              }

              if (Status === "Pending") acc[OfficeCode].PendingTotalCount += TotalCount;
              if (Status === "Allocated") acc[OfficeCode].AllocatedTotalCount += TotalCount;
              if (Status === "Resolved") acc[OfficeCode].ResolvedTotalCount += TotalCount;
              if (Status === "Closed") acc[OfficeCode].ClosedTotalCount += TotalCount;
              if (Status === "Onhold") acc[OfficeCode].OnholdTotalCount += TotalCount;

              acc[OfficeCode].TotalCount += TotalCount;

              return acc;
            }, {})
          );

          const filteredData = mergedData.filter(item => {
            const itemCode = String(item.OfficeCode);
            const targetCode = String(officeCode ? officeCode : code.slice(0, 2));
            if (targetCode.length === 5) {
              return itemCode === targetCode;
            } else {
              return itemCode.startsWith(targetCode) && itemCode.length === targetCode.length + 1;
            }
          });
          setTableData(filteredData);
        }
        else if (result.status === "400" && result.message == "Data not found.") {
          setTableData([]);
        }

        setViewBackdrop(false);
      })
      .catch((error) => {
        setTableData([]);
        setViewBackdrop(false);
      });
  };




  function formatWithCommas(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const tableStyle = {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: '5px',
    textAlign: 'center',
    fontSize: '15px',
  };


  const thTdStyle = {
    border: 'none',
    padding: '0px 8px',
    fontSize: '14px'
  };

  const subdivthTdStyle = {
    border: 'none',
    padding: '6px 7px',
    backgroundColor: '#d5e5fc',
    fontSize: '15px',
    fontWeight: 'bold'
  };

  const headerStyle = {
    backgroundColor: '#eeeff0',
    border: 'none',
    fontSize: '15px',
    paddingTop: '10px' // Extra space above headers
  };

  const currentFilters = {
      officeCode, dateFrom, dateTo
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged = JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [
    officeCode, dateFrom, dateTo
  ]);

  const handleGoClick = () => {
  const apiOfficeCode = resolveReportGoOfficeCode({
    code,
    officeCode,
    selectedCompanyCode,
    selectedAdminCompanyCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
  });
    fetchData(apiOfficeCode, dateFrom, dateTo)

    setLastAppliedFilters({ ...currentFilters });

    setIsGoDisabled(true);
  };

  const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  const reportOfficeLabel = officeName || "All Offices";
  const tableCaptionText =
    dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
      ? `Complaints Summary Report for ${reportOfficeLabel} – ${convertDate(dateFrom)}`
      : `Complaints Summary Report for ${reportOfficeLabel} from ${dateFrom ? convertDate(dateFrom) : "-"} to ${dateTo ? convertDate(dateTo) : "-"}`;

  return (
    <>
      <Box className="form-box rpt-page coa-status-report complaints-summary-page">
        <div className="coa-layout">
          <Box className="application-table" style={{ marginRight: "0px", width: "100%" }}>
            <header className="coa-page-header">
              <h1 className="coa-page-title">Complaints Summary</h1>
            </header>
            <div className="div-datagrid">
              <div className="coa-toolbar-stack">
                <Paper
                  variant="outlined"
                  className="coa-card coa-card--filters"
                  sx={{
                    p: 2,
                    width: "100%",
                    bgcolor: "#fff",
                    borderRadius: 2,
                    borderColor: "divider",
                  }}
                >
                  <div
                    className="coa-filters coa-filters--mui-grid"
                    style={{ width: "100%" }}
                  >
                    <Grid container spacing={2} alignItems="flex-end">


                      <Grid item xs={12} sm={6} md={2}>
                        <Stack spacing={0.5}>
                          <Typography className="field-label">Date From</Typography>
                          <input
                            type="date"
                            className="date-field cs-filter-input"
                            value={dateFrom}
                            max={getTodayIsoDate()}
                            onChange={(e) => {
                              setDateFrom(clampIsoDateToToday(e.target.value));
                            }}
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={12} sm={6} md={2}>
                        <Stack spacing={0.5}>
                          <Typography className="field-label">Date To</Typography>
                          <input
                            type="date"
                            className="date-field cs-filter-input"
                            value={dateTo}
                            max={getTodayIsoDate()}
                            onChange={(e) => {
                              setDateTo(clampIsoDateToToday(e.target.value));
                            }}
                          />
                        </Stack>
                      </Grid>
                      {code == 10 && (
                        <Grid item xs={12} sm={6} md={2}>
                          <Stack spacing={0.5}>
                            <Typography className="field-label">Company</Typography>
                            <select
                              className="dropdown-field cs-filter-input"
                              value={selectedCompanyCode}
                              onChange={handleChangeCompany}
                            >
                        <option value="10">Select Company</option>
                        <option value="11">LESCO</option>
                        <option value="12">GEPCO</option>
                        <option value="13">FESCO</option>
                        <option value="14">IESCO</option>
                        <option value="15">MEPCO</option>
                        <option value="26">PESCO</option>
                        <option value="27">HAZECO</option>
                        <option value="37">HESCO</option>
                        <option value="38">SEPCO</option>
                        <option value="48">QESCO</option>
                        <option value="59">TESCO</option>
                            </select>
                          </Stack>
                        </Grid>
                      )}

                      {hierarchy <= 2 && (
                        <Grid item xs={12} sm={6} md={2}>
                          <Stack spacing={0.5}>
                            <Typography className="field-label">Circle</Typography>
                            <select
                              className="dropdown-field cs-filter-input"
                              value={circleCode || ""}
                              onChange={handleCircleChange}
                            >
                        <option value="">All Circle</option>
                        {filteredCircles.map((circle) => (
                          <option key={circle.circleCode} value={circle.circleCode}>
                            {circle.circleName}
                          </option>
                        ))}
                            </select>
                          </Stack>
                        </Grid>
                      )}

                      {hierarchy <= 3 && (
                        <Grid item xs={12} sm={6} md={2}>
                          <Stack spacing={0.5}>
                            <Typography className="field-label">Division</Typography>
                            <select
                              className="dropdown-field cs-filter-input"
                              value={selectedDivision || ""}
                              onChange={handleDivisionChange}
                              disabled={!circleCode}
                            >
                        <option value="">All Division</option>
                        {filteredDivisions.map((division) => (
                          <option key={division.divisionCode} value={division.divisionCode}>
                            {division.divisionName}
                          </option>
                        ))}
                            </select>
                          </Stack>
                        </Grid>
                      )}

                      {hierarchy <= 4 && (
                        <Grid item xs={12} sm={6} md={2}>
                          <Stack spacing={0.5}>
                            <Typography className="field-label">Sub-Division</Typography>
                            <select
                              className="dropdown-field cs-filter-input"
                              value={selectedSubDivision || ""}
                              onChange={handleSubDivisionChange}
                              disabled={!selectedDivision}
                            >
                        <option value="">All Sub-Division</option>
                        {filteredSubDivisions.map((subDivision) => (
                          <option key={subDivision.subDivisionCode} value={subDivision.subDivisionCode}>
                            {subDivision.subDivisionName}
                          </option>
                        ))}
                            </select>
                          </Stack>
                        </Grid>
                      )}
                      <Grid item xs={12} sm={6} md={2}>
                        <Stack spacing={0.5}>
                          <Box
                            aria-hidden
                            sx={{
                              height: "1.35rem",
                              mb: 0.5,
                              lineHeight: 1.35,
                            }}
                          />
                          <Button
                            fullWidth
                            variant="contained"
                            disableElevation
                            className="coa-go-btn"
                            onClick={handleGoClick}
                            disabled={isGoDisabled || viewBackdrop}
                          >
                            GO
                          </Button>
                        </Stack>
                      </Grid>
                    </Grid>
                  </div>
                  <Stack
                    direction="row"
                    flexWrap="wrap"
                    alignItems="center"
                    justifyContent={{ xs: "flex-start", md: "flex-end" }}
                    spacing={1}
                    className="coa-export-strip"
                    sx={{
                      pt: 2,
                      mt: 2,
                      borderTop: "1px solid",
                      borderColor: "divider",
                      gap: 1,
                    }}
                  >
                    <ReportExportButtons
                      isEmpty={tableData.length === 0}
                      onEmpty={noDataAvailable}
                      onPdf={() => DownloadPdf(true)}
                      onExcel={exportToExcel}
                      onPrint={printPDF}
                    />
                  </Stack>
                </Paper>
              </div>
              <div className="coa-report-banner" role="status">
                {tableCaptionText}
              </div>
              <div className="table-container" style={{ marginBottom: "40px" }}>
                <div id="pdf-table">
                  <div className="coa-table-scroll">
                    <table
                      className="table"
                      ref={tableRef}
                      style={{
                        marginBottom: "40px",
                        width: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          backgroundColor: "white",
                          zIndex: 10,
                        }}
                      >
                        <tr>
                          {connectionTypes.map((type, index) => (
                            <th key={index}>{type}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {tableData && tableData.length > 0 ? (
                          <>
                            {tableData.map((item, id) => (
                              <tr
                                key={id}
                                style={{
                                  backgroundColor:
                                    id % 2 === 0 ? "#f8f9fa" : "#e3efff",
                                }}
                              >
                                <td style={{ textAlign: "left" }}>
                                  {item.OfficeName || "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.PendingTotalCount
                                    ? formatWithCommas(item.PendingTotalCount)
                                    : "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.AllocatedTotalCount
                                    ? formatWithCommas(item.AllocatedTotalCount)
                                    : "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.OnholdTotalCount
                                    ? formatWithCommas(item.OnholdTotalCount)
                                    : "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.ResolvedTotalCount
                                    ? formatWithCommas(item.ResolvedTotalCount)
                                    : "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.ClosedTotalCount
                                    ? formatWithCommas(item.ClosedTotalCount)
                                    : "-"}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.TotalCount
                                    ? formatWithCommas(item.TotalCount)
                                    : "-"}
                                </td>
                              </tr>
                            ))}
                            <tr className="cs-total-row">
                              <td style={{ textAlign: "left", fontWeight: "bold" }}>
                                Total
                              </td>
                              <td style={{ textAlign: "center", fontWeight: "bold" }}>
                                {formatWithCommas(
                                  tableData.reduce(
                                    (sum, item) =>
                                      sum + (item.PendingTotalCount || 0),
                                    0,
                                  ),
                                )}
                              </td>
                              <td style={{ textAlign: "center", fontWeight: "bold" }}>
                                {formatWithCommas(
                                  tableData.reduce(
                                    (sum, item) =>
                                      sum + (item.AllocatedTotalCount || 0),
                                    0,
                                  ),
                                )}
                              </td>
                              <td style={{ textAlign: "center", fontWeight: "bold" }}>
                                {formatWithCommas(
                                  tableData.reduce(
                                    (sum, item) =>
                                      sum + (item.OnholdTotalCount || 0),
                                    0,
                                  ),
                                )}
                              </td>
                              <td style={{ textAlign: "center", fontWeight: "bold" }}>
                                {formatWithCommas(
                                  tableData.reduce(
                                    (sum, item) =>
                                      sum + (item.ResolvedTotalCount || 0),
                                    0,
                                  ),
                                )}
                              </td>
                              <td style={{ textAlign: "center", fontWeight: "bold" }}>
                                {formatWithCommas(
                                  tableData.reduce(
                                    (sum, item) =>
                                      sum + (item.ClosedTotalCount || 0),
                                    0,
                                  ),
                                )}
                              </td>
                              <td style={{ textAlign: "center", fontWeight: "bold" }}>
                                {formatWithCommas(
                                  tableData.reduce(
                                    (sum, item) => sum + (item.TotalCount || 0),
                                    0,
                                  ),
                                )}
                              </td>
                            </tr>
                          </>
                        ) : !viewBackdrop ? (
                          <tr className="cs-empty-row">
                            <td colSpan={connectionTypes.length}>
                              No Data Found
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
              >
                <AppLoader />
              </Backdrop>







            </div>
          </Box>
        </div>
      </Box>

    </>
  )
}

export default ComplaintsSummary